export default variable => typeof variable === "undefined"